import { Component, Input, TemplateRef } from '@angular/core';
import { Align } from '@progress/kendo-angular-popup';

@Component({
    selector: 'side-panel',
    templateUrl: 'side-panel.component.html'
})

export class SidePanelComponent {
    @Input() anchor: any;
    @Input() animate: any = {
        type: 'slide',
        direction: 'left',
        duration: 200
    };
    @Input() anchorAlign: Align = { horizontal: "right", vertical: "center" };
    @Input() popupAlign: Align = { horizontal: "right", vertical: "center" };
    @Input() showPanel: boolean = false;
    @Input() content: TemplateRef<any>;
}